import { ExtendedOption } from "@multiweb/types/react";

/**
 * Option pro comboboxy.
 */
export type ComboBoxOption = {
    /** Příznak značící, zda se má option skrýt */
    hide?: boolean;
    /** Příznak značící, zda se jedná o placeholder option */
    isPlaceholder?: boolean;
} & ExtendedOption<string | number, string>;
